import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Column, Row } from '@chargify/custom-ui-components';
import { CustomField } from '@chargify/custom-fields';
import { DetailsRow } from '../DetailsRow';
import { CustomFieldsLoadingSkeleton } from './components';

export type Props = {
  /**
   * Custom fields
   */
  customFields: CustomField[];
  /**
   * On edit
   */
  onEdit: () => void;
};

const CustomFieldsPreview = ({ customFields, onEdit }: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);
  return (
    <Row>
      {customFields &&
        customFields.map((customField) => (
          <DetailsRow
            label={customField.name}
            value={customField.value}
            key={customField.id}
          />
        ))}
      <Column span={24}>
        <Button
          onClick={onEdit}
          color={'secondary'}
          iconLeft="edit"
          label={t('custom_fields.edit_additional_settings')}
        />
      </Column>
    </Row>
  );
};

CustomFieldsPreview.LoadingSkeleton = CustomFieldsLoadingSkeleton;

export default CustomFieldsPreview;
